import React from 'react'

function Commodity({ src, alt, heading, text }) {
  return (
      <div className='p-2'>
          <div className='flex flex-col md:flex-row items-center gap-4'>
              <div className='w-full md:w-1/2'>
                  <img className='h-[400px] w-full shadow-2xl'
                      src={src}
                      alt={alt} />
              </div>
              <div className='w-full md:w-1/2'>
                  <h1 className='mb-3 text-center text-3xl font-open-sans font-medium'>{heading}</h1>
                  <p className='text-center text-md font-roboto font-light'>{text}</p>
              </div>
          </div>
      </div>
  )
}

export default Commodity